export const mutations = {
    setSummary: (state, summary) => {
        state.summary = summary;
    },
};